import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section
      id="home"
      className="relative min-h-[600px] md:min-h-[700px] w-full overflow-hidden"
    >
      {/* Background image only */}
      <div className="absolute inset-0">
        <img
          src="/images/bg.webp"
          alt="대전이혼전문변호사 신가영 변호사"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Left-side gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent z-[5] pointer-events-none" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 md:pt-28 pb-12 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-between gap-8 lg:gap-12 max-w-7xl mx-auto min-h-[480px] md:min-h-[560px]">
          {/* Text content on the left side */}
          <div className="flex-1 flex flex-col justify-center items-center lg:items-start text-center lg:text-left">
            <div className="inline-flex items-center gap-3 text-white/80 text-sm md:text-base font-medium mb-4 md:mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 flex-shrink-0" />
              {t('hero.title')}
              <span className="w-16 md:w-24 h-px bg-white/40 inline-block" />
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
              {t('hero.subtitle')}
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-4 md:mb-5 max-w-lg mx-auto lg:mx-0">
              {t('hero.tagline')}
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 md:gap-4">
              <a
                href="tel:010-2833-1395"
                className="flex items-center justify-center gap-2 bg-primary-500 text-background-50 min-w-[200px] px-10 md:px-12 py-3 md:py-3.5 rounded-lg text-sm md:text-base font-semibold hover:-translate-y-1 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
              >
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </span>
                {t('hero.cta.call')}
              </a>
              <a
                href="https://m.booking.naver.com/booking/6/bizes/1236562?theme=place&entry=pll&lang=ko"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center justify-center gap-2 bg-background-50 text-primary-700 min-w-[200px] px-10 md:px-12 py-3 md:py-3.5 rounded-lg text-sm md:text-base font-semibold hover:-translate-y-1 hover:bg-background-100 transition-all duration-300 whitespace-nowrap"
              >
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-sm"></i>
                </span>
                {t('hero.cta.booking')}
              </a>
            </div>

            {/* YouTube channel - simple text link */}
            <a
              href="https://www.youtube.com/@LAW_3minute"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 mt-5 md:mt-6 text-white/80 text-sm md:text-base hover:text-white transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-red-500">
                <i className="ri-youtube-fill text-base md:text-lg"></i>
              </span>
              유튜브 채널 '3분 변호사'
            </a>

          </div>

          {/* Right side - Lawyer portrait */}
          <div className="hidden lg:flex flex-shrink-0 items-end justify-center w-[420px] relative rounded-2xl overflow-hidden border-2 border-white/40 backdrop-blur-md">
            {/* Noise texture overlay */}
            <div
              className="absolute inset-0 z-10 pointer-events-none opacity-[0.14] mix-blend-soft-light"
              style={{
                backgroundImage:
                  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
              }}
            />
            <img
              src="/images/pro_t.png"
              alt="대전이혼전문변호사 신가영 변호사"
              className="w-full h-auto max-h-[560px] object-contain object-bottom z-20 relative"
            />
            {/* Name tag overlay */}
            <div className="absolute bottom-0 left-0 right-0 z-30">
              <div className="w-full px-6 py-5 text-center rounded-b-2xl">
                <p className="text-accent-400 font-label text-xs tracking-[0.3em] uppercase mb-2">
                  이혼전문변호사
                </p>
                <p className="text-white font-heading text-2xl md:text-3xl font-bold leading-tight">
                  신가영
                </p>
                <div className="flex items-center justify-center gap-2 my-3">
                  <span className="w-10 h-px bg-accent-400/70" />
                  <span className="w-1.5 h-1.5 rotate-45 bg-accent-400" />
                  <span className="w-10 h-px bg-accent-400/70" />
                </div>
                <p className="text-white/70 text-sm leading-relaxed">
                  여성변호사 특유의 꼼꼼함으로 첫 상담부터 판결까지
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}